// =============================================================================
// Core: Modules
// =============================================================================

import _Base from './core--base';

class _Modules extends _Base {
    constructor(module) {
        super();
        this.module = module;
        // The add function updates the modules settings that are there for the next
        // object. But everytime default settings are needed
        this.module.defaultSettingsCached = this.module.settings;
        // Settings are not available here as it's before ready. See add function.
    }

    add(moduleSettings) {
        this.module.settings = {
            ...this.module.defaultSettingsCached,
            ...moduleSettings
        };

        // 2. Fire module with new settings, returns any methods returned in a specific module for public access
        return this.module.fn();
    }
}

export default _Modules;
